/**
 * @author Daniel Gong
 */
qsTemplate.create('depleted-template', {
    path: 'templates/KO/depleted-template/depleted-template.html'
});

/*qsTemplate.create('top-menu', {
    path: 'templates/KO/top-menu/top-menu.html'
});*/

qsTemplate.create('side-bar', {
    path: 'templates/KO/side-bar/side-bar.html',
    js: ['templates/KO/side-bar/side-bar.js'],
    // bind model to the view, there are many ways to define a view model,
    // what to put in "viewModelName" depends on how your model is defined.
    viewModelName: 'moveInViewModel.sidebar',
    onload: function(viewModel) {
        viewModel.init();
    }
});

/*qsTemplate.create('modification-history-box', {
    path: 'templates/KO/modification-history/modification-history-box.html',
    js: [
        'templates/KO/modification-history/modification-history-box.js',
    ]
});*/

qsTemplate.create('person-details', {
    path: 'templates/KO/person-details/person-details.html',
    js: ['templates/KO/person-details/person-details.js'],
    viewModelName: 'moveInViewModel.personDetails'
});

qsTemplate.create('advanced-grid', {
    path: 'templates/KO/advanced-grid/advanced-grid.html',
    js: [
        'templates/KO/advanced-grid/advanced-grid.js',
        'templates/KO/advanced-grid/advanced-grid-list.js',
        'templates/KO/advanced-grid/advanced-grid-sort.js',
        'templates/KO/advanced-grid/advanced-grid-filter.js'
    ],
    onload: function(viewModel, rootNode) {
        $(rootNode).find('.advanced-grid-scrollbar').mCustomScrollbar();
    }
});

qsTemplate.create('leads', {
    path: 'templates/KO/leads/leads.html',
    js: ['templates/KO/leads/leads.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.leadsGrid'
});

qsTemplate.create('opportunities', {
    path: 'templates/KO/opportunities/opportunities.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/opportunities/opportunities.js'],
    viewModelName: 'moveInViewModel.opportunitiesGrid'
});

qsTemplate.create('applications', {
    path: 'templates/KO/applications/applications.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/applications/applications.js'],
    viewModelName: 'moveInViewModel.applicationsGrid'
});

qsTemplate.create('interviews', {
    path: 'templates/KO/interviews/interviews.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/interviews/interviews.js'],
    viewModelName: 'moveInViewModel.interviewsGrid'
});

qsTemplate.create('deposits', {
    path: 'templates/KO/deposits/deposits.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/deposits/deposits.js'],
    viewModelName: 'moveInViewModel.depositsGrid'
});

qsTemplate.create('events', {
    path: 'templates/KO/event/event.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/event/event.js'],
    viewModelName: 'moveInViewModel.eventsGrid'
});

qsTemplate.create('modification-history', {
    path: 'templates/KO/modification-history/modification-history.html',
    js: ['templates/KO/modification-history/modification-history.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.modificationHistory'
});

qsTemplate.create('modification-history-system-admin', {
    path: 'templates/KO/modification-history/modification-history-system-admin.html',
    js: ['templates/KO/modification-history/modification-history-system-admin.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.modificationHistorySystemAdmin'
});

qsTemplate.create('modification-history-program-admin', {
    path: 'templates/KO/modification-history/modification-history-program.html',
    js: ['templates/KO/modification-history/modification-history-program.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.modificationHistoryProgramAdmin'
});

qsTemplate.create('modification-history-forms', {
    path: 'templates/KO/modification-history/modification-history-forms.html',
    js: ['templates/KO/modification-history/modification-history-forms.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.modificationHistoryForms'
});

qsTemplate.create('email-campaign-stats', {
    path: 'templates/KO/email-campaign/email-campaign-stats.html',
    js: ['templates/KO/email-campaign/email-campaign-stats.js',
         'js/validator.js',
         'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.emailCampaign'
});

qsTemplate.create('email-campaign-form', {
    path: 'templates/KO/email-campaign/email-campaign-form.html',
    js: ['js/validator.js',
         'templates/KO/advanced-grid/movein-advanced-grid.js',
         'templates/KO/email-campaign/email-campaign-form.js'],
    viewModelName: 'moveInViewModel.emailCampaignForm'
});

qsTemplate.create('email-campaign-user', {
    path: 'templates/KO/email-campaign/email-campaign-user.html',
    js: ['templates/KO/email-campaign/email-campaign-user.js'],
    viewModelName: 'moveInViewModel.emailCampaignUser'
});

qsTemplate.create('email-campaign-user-stats', {
    path: 'templates/KO/email-campaign/email-campaign-user-stats.html',
    js: ['templates/KO/email-campaign/email-campaign-user-stats.js',
         'templates/KO/email-campaign/email-campaign-user.js'],
    viewModelName: 'moveInViewModel.emailCampaignUserStats'
});




qsTemplate.create('drop-down-box', {
    path: 'templates/KO/drop-down-box/drop-down-box.html',
    js: ['templates/KO/drop-down-box/drop-down-box.js'],
    viewModelName: 'DropDownBox()'
});

qsTemplate.create('search-box', {
    path: 'templates/KO/shared/search-box/search-box.html',
    js: ['templates/KO/shared/search-box/search-box.js'],
    viewModelName: 'moveInViewModel.SearchBox()'
});

qsTemplate.create('file-repository', {
    path: 'templates/KO/shared/file-repository/file-repository.html',
    js: ['templates/KO/shared/file-repository/file-repository.js'],
    viewModelName: 'moveInViewModel.fileRepository'
});

qsTemplate.create('auto-suggest-box', {
    path: 'templates/KO/shared/auto-suggest-box/auto-suggest-box.html',
    js: ['templates/KO/shared/auto-suggest-box/auto-suggest-box.js'],
    viewModelName: 'moveInViewModel.AutoSuggestBox()'
});

qsTemplate.create('movein-date-picker', {
    path: 'templates/KO/movein-date-picker/movein-date-picker.html',
    js: ['templates/KO/movein-date-picker/movein-date-picker.js'],
    viewModelName: 'MoveInDatePicker()',
    onload: function(viewModel, rootNode) {
        viewModel.init(rootNode, moveInViewModel.datePickerFormat());
    }
});

qsTemplate.create('movein-datetime-picker', {
    path: 'templates/KO/movein-date-picker/movein-datetime-picker.html',
    js: ['templates/KO/movein-date-picker/movein-date-picker.js'],
    viewModelName: 'MoveInDatePicker()',
    onload: function(viewModel, rootNode) {
        viewModel.init(rootNode, moveInViewModel.datePickerFormat());
    }
});

qsTemplate.create('text-box', {
    path: 'templates/KO/shared/text-box/text-box.html',
    js: ['templates/KO/shared/text-box/text-box.js'],
    viewModelName: 'moveInViewModel.TextBox()'
});

/**
 * object for all actions on import csv page
 * @author:Mudassar Ali
 */
/*qsTemplate.create('import-csv', {
    path: 'templates/KO/import-csv/import-csv.html',
    js: ['templates/KO/import-csv/import-csv.js'],
    viewModelName: 'moveInViewModel.importCsv',
});*/

/*qsTemplate.create('program-admin', {
    path: 'templates/KO/program-admin/program-admin.html',
    js: [
        'templates/KO/program-admin/program-admin.js',

    ]
});*/
/*qsTemplate.create('form-admin', {
    path: 'templates/KO/form-admin/form-admin.html',
    js: [
        'templates/KO/form-admin/form-admin.js',
        'templates/KO/form-admin/form-answers.js'
       /* 'templates/KO/form-admin/entity-forms.js',
        'templates/KO/form-admin/portal.js',
        'templates/KO/form-admin/form-answers.js'
    ]
});*/
/*
qsTemplate.create('my-activities', {
    path: 'templates/KO/my-activities/my-activities.html',
    js: ['templates/KO/my-activities/my-activities.js']
});*/

qsTemplate.create('my-activity-emails', {
	path: 'templates/KO/my-activities/emails.html',
	js: ['templates/KO/my-activities/emails.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivityEmails'
});

qsTemplate.create('my-activity-notes', {
	path: 'templates/KO/my-activities/notes.html',
	js: ['templates/KO/my-activities/notes.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivityNotes'
});

qsTemplate.create('my-activity-phonecalls', {
	path: 'templates/KO/my-activities/phonecalls.html',
	js: ['templates/KO/my-activities/phonecalls.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivityPhoneCalls'
});

qsTemplate.create('my-activity-email-templates', {
	path: 'templates/KO/my-activities/emailtemplates.html',
	js: ['templates/KO/my-activities/emailtemplates.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivityEmailTemplates'
});

qsTemplate.create('my-activity-document', {
	path: 'templates/KO/my-activities/document.html',
	js: ['templates/KO/my-activities/document.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivityDocuments'
});

qsTemplate.create('my-activity-system-document-templates', {
	path: 'templates/KO/my-activities/systemdocumenttemplate.html',
	js: ['templates/KO/my-activities/systemdocumenttemplate.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivitySystemDocumentTemplates'
});

qsTemplate.create('my-activity-document-templates', {
	path: 'templates/KO/my-activities/documenttemplate.html',
	js: ['templates/KO/my-activities/documenttemplate.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivityDocumentTemplates'
});
qsTemplate.create('brevo-emails', {
    path: 'templates/KO/my-activities/brevo-emails.html',
    js: ['templates/KO/my-activities/brevo-emails.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.brevoEmails'
});

qsTemplate.create('my-activity-tasks', {
	path: 'templates/KO/my-activities/tasks.html',
	js: ['templates/KO/my-activities/tasks.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
	viewModelName: 'moveInViewModel.myActivityTasks'
});

qsTemplate.create('my-interview-sheet', {
    path: 'templates/KO/my-interview-sheet/my-interview-sheet.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/my-interview-sheet/my-interview-sheet.js'],
    viewModelName: 'moveInViewModel.myInterviewSheet'
});

qsTemplate.create('my-scoring-sheet', {
    path: 'templates/KO/my-scoring-sheet/my-scoring-sheet.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/my-scoring-sheet/my-scoring-sheet.js'],
    viewModelName: 'moveInViewModel.myScoringSheet'
});

/*qsTemplate.create('message-center', {
    path: 'templates/KO/person-details/message-center/message-center.html',
    js: ['templates/KO/person-details/message-center/message-center.js'],
    viewModelName: 'moveInViewModel.personDetailsmessageCenter'
});

qsTemplate.create('message-center-archived', {
    path: 'templates/KO/person-details/message-center-archived/message-center-archived.html',
    js: ['templates/KO/person-details/message-center-archived/message-center-archived.js'],
    viewModelName: 'moveInViewModel.personDetailsmessageCenterArchived'
});*/
qsTemplate.create('activity-form', {
    path: 'templates/KO/person-details/activityForm/activityForm.html',
    js: ['templates/KO/person-details/activityForm/activityForm.js'],
    viewModelName: 'moveInViewModel.activityForm'
});

/*qsTemplate.create('my-watchlist', {
    path: 'templates/KO/my-watchlist/my-watchlist.html',
    js: ['templates/KO/my-watchlist/my-watchlist.js']
});*/

qsTemplate.create('my-watchlist-emails', {
    path: 'templates/KO/my-watchlist/emails.html',
    js: ['templates/KO/my-watchlist/emails.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListEmails'
});

qsTemplate.create('my-watchlist-email-templates', {
    path: 'templates/KO/my-watchlist/emailtemplates.html',
    js: ['templates/KO/my-watchlist/emailtemplates.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListEmailTemplates'
});

qsTemplate.create('my-watchlist-document', {
    path: 'templates/KO/my-watchlist/document.html',
    js: ['templates/KO/my-watchlist/document.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListDocuments'
});

qsTemplate.create('my-watchlist-document-templates', {
    path: 'templates/KO/my-watchlist/documenttemplate.html',
    js: ['templates/KO/my-watchlist/documenttemplate.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListDocumentTemplates'
});

qsTemplate.create('my-watchlist-system-document-templates', {
    path: 'templates/KO/my-watchlist/systemdocumenttemplate.html',
    js: ['templates/KO/my-watchlist/systemdocumenttemplate.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListSystemDocumentTemplates'
});

qsTemplate.create('my-watchlist-opportunity', {
    path: 'templates/KO/my-watchlist/opportunity.html',
    js: ['templates/KO/my-watchlist/opportunity.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListOpportunity'
});

qsTemplate.create('my-watchlist-application', {
    path: 'templates/KO/my-watchlist/application.html',
    js: ['templates/KO/my-watchlist/application.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListApplications'
});

qsTemplate.create('my-watchlist-notes', {
    path: 'templates/KO/my-watchlist/notes.html',
    js: ['templates/KO/my-watchlist/notes.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListNotes'
});

qsTemplate.create('my-watchlist-phonecalls', {
    path: 'templates/KO/my-watchlist/phonecalls.html',
    js: ['templates/KO/my-watchlist/phonecalls.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myWatchListPhoneCalls'
});

qsTemplate.create('lead-source-answer', {
    path: 'templates/KO/lead-source-answer/lead-source-answer.html',
    js: ['templates/KO/lead-source-answer/lead-source-answer.js'],
    viewModelName: 'moveInViewModel.leadSourceAnswers',
    onload: function(viewModel) {
        viewModel.init(viewModel.leadSourceId);
    }
});

/*qsTemplate.create('system-admin', {
    path: 'templates/KO/system-admin/system-admin.html',
    js: ['templates/KO/system-admin/system-admin.js'],
    viewModelName: 'moveInViewModel.systemAdmin'
});*/


qsTemplate.create('bulk-edit', {
    path: 'templates/KO/advanced-grid/bulk-edit/bulk-edit.html',
    js: ['templates/KO/advanced-grid/bulk-edit/bulk-edit.js'],
    viewModelName : 'moveInViewModel.bulkEdit'
});

qsTemplate.create('bulk-edit-step1', {
    path: 'templates/KO/advanced-grid/bulk-edit/bulk-edit-step1.html',
    js: ['templates/KO/advanced-grid/bulk-edit/bulk-edit-step1.js'],
    viewModelName : 'moveInViewModel.bulkEdit.step1',
});

qsTemplate.create('bulk-edit-step2', {
    path: 'templates/KO/advanced-grid/bulk-edit/bulk-edit-step2.html',
    js: ['templates/KO/advanced-grid/bulk-edit/bulk-edit-step2.js'],
    viewModelName : 'moveInViewModel.bulkEdit.step2',
});

qsTemplate.create('bulk-edit-step3', {
    path: 'templates/KO/advanced-grid/bulk-edit/bulk-edit-step3.html',
    js: ['templates/KO/advanced-grid/bulk-edit/bulk-edit-step3.js'],
    viewModelName : 'moveInViewModel.bulkEdit.step3',
});

qsTemplate.create('my-email-campaigns', {
	path: 'templates/KO/email-campaign/my-email-campaigns.html',
    js: ['templates/KO/email-campaign/my-email-campaigns.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.myEmailCampaignGrid',
});

qsTemplate.create('recipient-list-grid', {
    path: 'templates/KO/email-campaign/recipient-list.html',
    js: ['templates/KO/email-campaign/recipient-list.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.recipientListGrid',
});

//for custom list grid
qsTemplate.create('system-admin-custom-list-grid', {
    path: 'templates/KO/system-admin/custom-list/custom-list-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/custom-list/custom-list-grid.js'],
    viewModelName: 'moveInViewModel.customListGrid'
});

qsTemplate.create('system-admin-custom-area-grid', {
    path: 'templates/KO/system-admin/custom-area/custom-area-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/custom-area/custom-area-grid.js'],
    viewModelName: 'moveInViewModel.customAreaGrid'
});

//for custom list grid
qsTemplate.create('system-admin-visibility-criteria-grid', {
    path: 'templates/KO/system-admin/visibility-criteria/visibility-criteria-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/visibility-criteria/visibility-criteria-grid.js'],
    viewModelName: 'moveInViewModel.visibilityCriteriaGrid'
});

qsTemplate.create('merge-duplicates', {
    path: 'templates/KO/merge-duplicates/merge-duplicates.html',
    js: ['templates/KO/merge-duplicates/merge-duplicates.js'],
    viewModelName: 'moveInViewModel.mergeDuplicates'
});

qsTemplate.create('movein-ck-editor', {
    path: 'templates/KO/movein-text-editor/movein-ck-editor.html',
    js: ['templates/KO/movein-text-editor/movein-ck-editor.js'],
    viewModelName: 'MoveinCKEditor()',
    onload: function(viewModel) {
        viewModel.init();
    }
});

qsTemplate.create('generated-pdf', {
    path: 'templates/KO/generated-pdf/generated-pdf.html',
    js: ['templates/KO/generated-pdf/generated-pdf.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.generatedPdf'
});

qsTemplate.create('generated-csv-excel-files', {
    path: 'templates/KO/generated-csv-excel-files/generated-csv-excel-files.html',
    js: ['templates/KO/generated-csv-excel-files/generated-csv-excel-files.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.generatedCsvExcelFiles'
});

/*
qsTemplate.create('automated-export-files', {
    path: 'templates/KO/automated-export-files/automated-export-files.html',
    js: ['templates/KO/automated-export-files/automated-export-files.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.automatedExportFiles'
});
*/

qsTemplate.create('form-elements', {
    path: 'templates/KO/shared/form-elements.html'
});

qsTemplate.create('scoring-sheets', {
	    path : 'templates/KO/scoring-sheets/scoring-sheets-grid.html',
    js: ['templates/KO/scoring-sheets/scoring-sheets-grid.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.ScoringSheetsGrid'
});

qsTemplate.create('interview-scoring-sheets', {
    path: 'templates/KO/scoring-sheets/interview-scoring-sheets-grid.html',
    js: ['templates/KO/scoring-sheets/interview-scoring-sheets-grid.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.InterviewScoringSheetsGrid'
});

qsTemplate.create('side-bar-contacts', {
    path: 'templates/KO/side-bar/my-contacts.html',
    js: ['templates/KO/side-bar/my-contacts.js'],
    viewModelName: 'moveInViewModel.myContacts'
});

qsTemplate.create('side-bar-forms', {
    path: 'templates/KO/side-bar/my-forms.html',
    js: ['templates/KO/side-bar/my-forms.js'],
    viewModelName: 'moveInViewModel.myForms'
});

qsTemplate.create('side-bar-applications', {
    path: 'templates/KO/side-bar/my-applications.html',
    js: ['templates/KO/side-bar/my-applications.js'],
    viewModelName: 'moveInViewModel.myApplications'
});

qsTemplate.create('side-bar-opportunities', {
    path: 'templates/KO/side-bar/my-opportunities.html',
    js: ['templates/KO/side-bar/my-opportunities.js'],
    viewModelName: 'moveInViewModel.myOpportunities'
});

qsTemplate.create('side-bar-leads', {
    path: 'templates/KO/side-bar/my-leads.html',
    js: ['templates/KO/side-bar/my-leads.js'],
    viewModelName: 'moveInViewModel.myLeads'
});

qsTemplate.create('side-bar-saved-searches', {
    path: 'templates/KO/side-bar/saved-searches.html',
    js: ['templates/KO/side-bar/saved-searches.js'],
    viewModelName: 'moveInViewModel.savedSearches'
});

qsTemplate.create('side-bar-message-center', {
    path: 'templates/KO/side-bar/my-message-center.html',
    js: ['templates/KO/side-bar/my-message-center.js'],
    viewModelName: 'moveInViewModel.myMessageCenter'
});

qsTemplate.create('admin-scoring-sheets', {
    path: 'templates/KO/scoring-sheets/admin-scoring-sheets-grid.html',
    js: ['templates/KO/scoring-sheets/admin-scoring-sheets-grid.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.adminScoringSheetGrid'
});

qsTemplate.create('admin-interview-scoring-sheets', {
    path: 'templates/KO/scoring-sheets/admin-interview-scoring-sheets-grid.html',
    js: ['templates/KO/scoring-sheets/admin-interview-scoring-sheets-grid.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.adminInterviewScoringSheetGrid'
});

qsTemplate.create('referees', {
    path: 'templates/KO/referees/referees.html',
    js: ['templates/KO/referees/referees.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.referees'
});

qsTemplate.create('bo-referees', {
    path: 'templates/KO/bo-referees/bo-referees.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/bo-referees/boReferees.js'],
    viewModelName: 'moveInViewModel.boReferees'
});

qsTemplate.create('contacts', {
    path: 'templates/KO/contacts/contacts.html',
    js: ['templates/KO/contacts/contacts.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.contacts'
});

qsTemplate.create('portal-accounts', {
    path: 'templates/KO/portal-accounts/portal-accounts.html',
    js: ['templates/KO/portal-accounts/portal-accounts.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.portalAccounts'
});

qsTemplate.create('forms', {
    path: 'templates/KO/forms/forms.html',
    js: ['templates/KO/forms/forms.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.forms'
});
qsTemplate.create('inquiries', {
    path: 'templates/KO/inquiries/inquiries.html',
    js: ['templates/KO/inquiries/inquiries.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.inquiries'
});
qsTemplate.create('recipient-list', {
    path: 'templates/KO/campaign-recipient-list/recipient-list.html',
    js: ['templates/KO/campaign-recipient-list/recipient-list.js','templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.recipientList'
});
qsTemplate.create('person-details-milestone', {
    path: 'templates/KO/person-details/milestone/milestone.html',
    js: ['templates/KO/person-details/milestone/milestone.js'],
    viewModelName: 'moveInViewModel.personDetails.quickEdit.milestone'
});

qsTemplate.create('custom-list-items', {
    path: 'templates/KO/custom-list-items/custom-list-items.html',
    js: ['templates/KO/custom-list-items/custom-list-items.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.customListItems'
});

qsTemplate.create('system-admin-milestones', {
    path: 'templates/KO/system-admin/milestones/milestones.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js','templates/KO/system-admin/milestones/milestones.js'],
    viewModelName: 'moveInViewModel.systemAdmin.milestones'
});

qsTemplate.create('user-roles-and-rights', {
    path: 'templates/KO/system-admin/user-roles-and-rights/user-roles-and-rights.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js','templates/KO/system-admin/user-roles-and-rights/user-roles-and-rights.js'],
    viewModelName: 'moveInViewModel.systemAdmin.userRolesAndRights'
});

qsTemplate.create('system-admin-automated-export', {
    path: 'templates/KO/system-admin/automated-export/automated-export-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/automated-export/automated-export-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminAutomatedExport'
        // no onload init here
});

qsTemplate.create('system-admin-automated-export-files', {
    path: 'templates/KO/system-admin/automated-export-files/automated-export-files.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/automated-export-files/automated-export-files.js'],
    viewModelName: 'moveInViewModel.systemAdminAutomatedExportFiles'
        // no onload init here
});

qsTemplate.create('system-admin-group', {
    path: 'templates/KO/system-admin/group/group.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/group/group.js'],
    viewModelName: 'moveInViewModel.systemAdminGroup'
        // no onload init here
});

qsTemplate.create('bulk-action-reports', {
    path: 'templates/KO/system-admin/bulk-action-reports/bulk-action-reports.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/bulk-action-reports/bulk-action-reports.js'],
    viewModelName: 'moveInViewModel.bulkActionReports'
    // no onload init here
});

qsTemplate.create('payment', {
    path: 'templates/KO/system-admin/payment/payment.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/payment/payment.js'],
    viewModelName: 'moveInViewModel.paymentGrid'
        // no onload init here
});

qsTemplate.create('imported-values', {
    path: 'templates/KO/system-admin/imported-values/imported-values.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/imported-values/imported-values.js'],
    viewModelName: 'moveInViewModel.importedValuesGrid'
        // no onload init here
});

// for users gird
qsTemplate.create('system-admin-users', {
    path: 'templates/KO/system-admin/users/users.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/users/users.js'],
    viewModelName: 'moveInViewModel.systemAdminUsers'
        // no onload init here
});

qsTemplate.create('system-admin-contact-manager', {
    path: 'templates/KO/system-admin/contact-manager/contact-manager.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/contact-manager/contact-manager.js'],
    viewModelName: 'moveInViewModel.systemAdminContactManagers'
});

// for users form
/*qsTemplate.create('system-admin-users-form', {
    path: 'templates/KO/system-admin/users/users-form.html',
    js: [ 'templates/KO/system-admin/users/users-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.usersForm'
        // no onload init here
});*/

qsTemplate.create('form-types', {
    path: 'templates/KO/system-admin/form-types/form-types.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/form-types/form-types.js'],
    viewModelName: 'moveInViewModel.formTypes'
});

/*qsTemplate.create('marketing-source-form', {
    path: 'templates/KO/system-admin/marketing-source/marketing-source-form.html',
    js: ['templates/KO/system-admin/marketing-source/marketing-source-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.marketingSourceForm'
});*/
qsTemplate.create('marketing-source', {
    path: 'templates/KO/system-admin/marketing-source/marketing-source.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js','templates/KO/system-admin/marketing-source/marketing-source.js'],
    viewModelName: 'moveInViewModel.marketingSource'
});
qsTemplate.create('status', {
    path: 'templates/KO/system-admin/status/status.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js','templates/KO/system-admin/status/status.js'],
    viewModelName: 'moveInViewModel.status'
});

// document repository grid
qsTemplate.create('system-admin-document-repository', {
    path: 'templates/KO/system-admin/document-repository/document-repository.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/document-repository/document-repository.js'],
    viewModelName: 'moveInViewModel.systemAdminDocumentRepository'
});

//document repository form
/*Commented because MID-4584 Refactoring of Document Repository */
/*qsTemplate.create('system-admin-document-repository-form', {
    path: 'templates/KO/system-admin/document-repository/document-repository-form.html',
    js: [ 'templates/KO/system-admin/document-repository/document-repository-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.documentRepositoryForm'
});*/

qsTemplate.create('system-admin-milestones-stages', {
    path: 'templates/KO/system-admin/milestones-stages/milestones-stages.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/milestones-stages/milestones-stages.js'],
    viewModelName: 'moveInViewModel.systemAdminMilestonesStages'
});
qsTemplate.create('system-admin-roles-rights', {
    path: 'templates/KO/system-admin/user-roles-rights/user-roles-rights.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/user-roles-rights/user-roles-rights.js'],
    viewModelName: 'moveInViewModel.systemAdminRolesRights'
});

// for document template  grid
qsTemplate.create('system-admin-document-templates', {
    path: 'templates/KO/system-admin/document-template/document-template.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/document-template/document-template.js'],
    viewModelName: 'moveInViewModel.systemAdminDocumentTemplate'
});

// for document template form
/*qsTemplate.create('system-admin-document-templates-form', {
    path: 'templates/KO/system-admin/document-template/document-template-form.html',
    js: [ 'templates/KO/system-admin/document-template/document-template-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.documentTemplateForm'
});*/

qsTemplate.create('system-admin-document-type', {
    path: 'templates/KO/system-admin/document-type/document-type.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/document-type/document-type.js'],
    viewModelName: 'moveInViewModel.systemAdminDocumentType'
});
qsTemplate.create('system-admin-email-template', {
    path: 'templates/KO/system-admin/email-template/email-template.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/email-template/email-template.js'],
    viewModelName: 'moveInViewModel.systemAdminEmailTemplate'
});

qsTemplate.create('system-admin-group-email-template', {
    path: 'templates/KO/system-admin/group-email-template/group-email-template.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/group-email-template/group-email-template.js'],
    viewModelName: 'moveInViewModel.systemAdminGroupEmailTemplate'
});

/*
qsTemplate.create('email-template-form', {
    path: 'templates/KO/system-admin/email-template/email-template-form.html',
    js: [ 'templates/KO/system-admin/email-template/email-template-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.systemAdminEmailTemplateForm'
});*/

/*qsTemplate.create('email-config-form', {
    path: 'templates/KO/system-admin/email-config/email-config-form.html',
    js: [ 'templates/KO/system-admin/email-config/email-config-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.systemAdminEmailConfigForm'
});*/


qsTemplate.create('system-admin-email-config', {
    path: 'templates/KO/system-admin/email-config/email-config.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/email-config/email-config.js'],
    viewModelName: 'moveInViewModel.systemAdminEmailConfig'
});
qsTemplate.create('system-admin-imported-csv-files', {
    path: 'templates/KO/system-admin/imported-csv-files/imported-csv-files.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/imported-csv-files/imported-csv-files.js'],
    viewModelName: 'moveInViewModel.systemAdminImportedCsvFiles'
});

//for custom list form
/*qsTemplate.create('system-admin-custom-list-form', {
    path: 'templates/KO/system-admin/custom-list/custom-list-form.html',
    js: ['templates/KO/system-admin/custom-list/custom-list-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.customListForm'
});*/

//for custom Attribue form
qsTemplate.create('system-admin-custom-attribute-form', {
    path: 'templates/KO/system-admin/custom-attribute/custom-attribute-form.html',
    js: ['templates/KO/system-admin/custom-attribute/custom-attribute-form.js'],
    viewModelName: 'moveInViewModel.systemAdmin.customAttributeForm'
});

qsTemplate.create('his-export', {
    path: 'templates/KO/system-admin/his-export/his-export.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js','templates/KO/system-admin/his-export/his-export.js'],
    viewModelName: 'moveInViewModel.systemAdmin.hisExport'
});

/*
qsTemplate.create('scoring-admin', {
    path: 'templates/KO/system-admin/scoring-admin/scoring-admin.html',
});*/

qsTemplate.create('scoring-form-grid', {
    path: 'templates/KO/system-admin/scoring-admin/entity-scoring-form.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js',
         'templates/KO/system-admin/scoring-admin/entity-scoring-form.js'],
    viewModelName: 'moveInViewModel.entityScoringForm'
});



/*qsTemplate.create('scoring-type-form', {
    path: 'templates/KO/system-admin/scoring-admin/scoring-type/scoring-type-form.html',
    js: ['templates/KO/system-admin/scoring-admin/scoring-type/scoring-type-form.js'],
    viewModelName: 'moveInViewModel.scoringTypeForm'
});*/

qsTemplate.create('scoring-type', {
    path: 'templates/KO/system-admin/scoring-admin/scoring-type/scoring-type.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js',
         'templates/KO/system-admin/scoring-admin/scoring-type/scoring-type.js'],
    viewModelName: 'moveInViewModel.scoringType'
});

/*qsTemplate.create('scoring-form-type-form', {
    path: 'templates/KO/system-admin/scoring-admin/scoring-form-type/scoring-form-type-form.html',
    js: ['templates/KO/system-admin/scoring-admin/scoring-form-type/scoring-form-type-form.js'],
    viewModelName: 'moveInViewModel.scoringFormTypeForm'
});*/

qsTemplate.create('scoring-form-type', {
    path: 'templates/KO/system-admin/scoring-admin/scoring-form-type/scoring-form-type.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js',
         'templates/KO/system-admin/scoring-admin/scoring-form-type/scoring-form-type.js'],
    viewModelName: 'moveInViewModel.scoringFormType'
});

qsTemplate.create('lead-source-status', {
    path: 'templates/KO/system-admin/lead-source-status/lead-source-status-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/lead-source-status/lead-source-status-grid.js'],
    viewModelName: 'moveInViewModel.leadSourceStatusGrid'
});

qsTemplate.create('admission-status', {
    path: 'templates/KO/system-admin/admission-status/admission-status-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/admission-status/admission-status-grid.js'],
    viewModelName: 'moveInViewModel.admissionStatusGrid'
});

qsTemplate.create('interview-status', {
    path: 'templates/KO/system-admin/interview-status/interview-status-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/interview-status/interview-status-grid.js'],
    viewModelName: 'moveInViewModel.interviewStatusGrid'
});

qsTemplate.create('interview-type', {
    path: 'templates/KO/system-admin/interview-type/interview-type-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/interview-type/interview-type-grid.js'],
    viewModelName: 'moveInViewModel.interviewTypeGrid'
});

qsTemplate.create('deposit-status', {
    path: 'templates/KO/system-admin/deposit-status/deposit-status-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/deposit-status/deposit-status-grid.js'],
    viewModelName: 'moveInViewModel.depositStatusGrid'
});

qsTemplate.create('process-automations', {
    path: 'templates/KO/system-admin/process-automation/process-automation-grid.html',
    js: ['templates/KO/system-admin/process-automation/process-automation-grid.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.processAutomationsGrid'
});

qsTemplate.create('group-automation', {
    path: 'templates/KO/system-admin/group-automation/group-automation-grid.html',
    js: ['templates/KO/system-admin/group-automation/group-automation-grid.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.groupAutomationGrid'
});

qsTemplate.create('programme-admin-programme-type', {
    path: 'templates/KO/program-admin/programme-type/programme-type-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/program-admin/programme-type/programme-type-grid.js'],
    viewModelName: 'moveInViewModel.programTypeGrid'
});

//for intake grid
qsTemplate.create('programme-admin-intake', {
    path: 'templates/KO/program-admin/intake/intake-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/program-admin/intake/intake-grid.js'],
    viewModelName: 'moveInViewModel.programAdminIntakeGrid'
});
// Rule Grid
qsTemplate.create('programme-admin-rule', {
    path: 'templates/KO/program-admin/rule/rule-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/program-admin/rule/rule-grid.js'],
    viewModelName: 'moveInViewModel.programAdminRuleGrid'
});

qsTemplate.create('programme-admin-institution', {
    path: 'templates/KO/program-admin/institution/institution.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/program-admin/institution/institution.js'],
    viewModelName: 'moveInViewModel.programAdminInstitutionGrid'
});


//for program grid
qsTemplate.create('programme-admin-programme', {
    path: 'templates/KO/program-admin/programme/programme-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/program-admin/programme/programme-grid.js'],
    viewModelName: 'moveInViewModel.programmeGrid'
});

qsTemplate.create('form-admin-portal', {
    path: 'templates/KO/form-admin/portal/portal-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/form-admin/portal/portal-grid.js'],
    viewModelName: 'moveInViewModel.portal'
});
qsTemplate.create('form-admin-contact-manager-portal', {
    path: 'templates/KO/form-admin/contact-manager-portal/contact-manager-portal-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/form-admin/contact-manager-portal/contact-manager-portal-grid.js'],
    viewModelName: 'moveInViewModel.contactManagerPortal'
});

//for portal form
qsTemplate.create('form-admin-portal-form', {
    path: 'templates/KO/form-admin/portal/portal-form.html',
    js: ['templates/KO/form-admin/portal/portal-form.js'],
    viewModelName: 'moveInViewModel.formAdmin.portalForm'
});
//for cntact manager portal form
qsTemplate.create('form-admin-contact-manager-portal-form', {
    path: 'templates/KO/form-admin/contact-manager-portal/contact-manager-portal-form.html',
    js: ['templates/KO/form-admin/contact-manager-portal/contact-manager-portal-form.js'],
    viewModelName: 'moveInViewModel.formAdmin.contactManagerPortalForm'
});
//for forms-form
qsTemplate.create('form-admin-forms-form', {
    path: 'templates/KO/form-admin/forms/forms-form.html',
    js: ['templates/KO/form-admin/forms/forms-form.js'],
    viewModelName: 'moveInViewModel.formAdmin.formsForm'
});
//for forms-grid
qsTemplate.create('form-admin-forms', {
    path: 'templates/KO/form-admin/forms/forms-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/form-admin/forms/forms-grid.js'],
    viewModelName: 'moveInViewModel.formsGrid'
});

//for interview forms
qsTemplate.create('form-admin-interview-forms-form', {
    path: 'templates/KO/form-admin/interview-forms/interview-forms-form.html',
    js: ['templates/KO/form-admin/interview-forms/interview-forms-form.js'],
    viewModelName: 'moveInViewModel.interviewFormsForm'
});
//for interview forms grid
qsTemplate.create('form-admin-interview-forms', {
    path: 'templates/KO/form-admin/interview-forms/interview-forms.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/form-admin/interview-forms/interview-forms.js'],
    viewModelName: 'moveInViewModel.interviewForms'
});

qsTemplate.create('form-admin-sessions', {
    path: 'templates/KO/form-admin/session/session-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/form-admin/session/session-grid.js'],
    viewModelName: 'moveInViewModel.sessions'
});

qsTemplate.create('system-admin-document-template-group', {
    path: 'templates/KO/system-admin/document-template-group/document-template-group.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/document-template-group/document-template-group.js'],
    viewModelName: 'moveInViewModel.systemAdminDocumentTemplateGroup'
});

qsTemplate.create('system-admin-data-access-roles', {
    path: 'templates/KO/system-admin/data-access-roles/data-access-roles.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/data-access-roles/data-access-roles.js'],
    viewModelName: 'moveInViewModel.systemAdminDataAccessRoles'
});

qsTemplate.create('program-status', {
    path: 'templates/KO/system-admin/program-status/program-status-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/program-status/program-status-grid.js'],
    viewModelName: 'moveInViewModel.programStatusGrid'
});

qsTemplate.create('system-admin-field-level-role', {
    path: 'templates/KO/system-admin/field-level-role/field-level-role.html',
    js: ['templates/KO/system-admin/field-level-role/field-level-role.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminFieldLevevlRole'
});

qsTemplate.create('system-admin-event-group', {
    path: 'templates/KO/system-admin/event-group/event-group.html',
    js: ['templates/KO/system-admin/event-group/event-group.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminEventGroup'
});

qsTemplate.create('system-admin-venue', {
    path: 'templates/KO/system-admin/venue/venue.html',
    js: ['templates/KO/system-admin/venue/venue.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminVenue'
});

qsTemplate.create('system-admin-event-status', {
    path: 'templates/KO/system-admin/event-status/event-status.html',
    js: ['templates/KO/system-admin/event-status/event-status.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminEventStatus'
});

qsTemplate.create('system-admin-event', {
    path: 'templates/KO/system-admin/event/event.html',
    js: ['templates/KO/system-admin/event/event.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminEvent'
});

qsTemplate.create('system-admin-api', {
    path: 'templates/KO/system-admin/api/api.html',
    js: ['templates/KO/system-admin/api/api.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminApi'
});

qsTemplate.create('system-admin-webhook', {
    path: 'templates/KO/system-admin/webhook/webhook.html',
    js: ['templates/KO/system-admin/webhook/webhook.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminWebhook'
});
qsTemplate.create('system-admin-consent-manager', {
    path: 'templates/KO/system-admin/consent-manager/consent-manager.html',
    js: ['templates/KO/system-admin/consent-manager/consent-manager.js', 'templates/KO/advanced-grid/movein-advanced-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminConsentManager'
});

qsTemplate.create('reputation-admin-subject-area', {
    path: 'templates/KO/reputation-admin/subject-area/subject-area-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/reputation-admin/subject-area/subject-area-grid.js'],
    viewModelName: 'moveInViewModel.subjectAreaGrid'
});

/*qsTemplate.create('reputation-admin-subject', {
    path: 'templates/KO/reputation-admin/subject/subject-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/reputation-admin/subject/subject-grid.js'],
    viewModelName: 'moveInViewModel.subjectGrid'
});

qsTemplate.create('reputation-admin-industry', {
    path: 'templates/KO/reputation-admin/industry/industry-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/reputation-admin/industry/industry-grid.js'],
    viewModelName: 'moveInViewModel.industryGrid'
});*/

qsTemplate.create('system-admin-subject', {
    path: 'templates/KO/system-admin/qs-data-hub/subject/subject-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/subject/subject-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminSubjectGrid'
});
qsTemplate.create('system-admin-industry', {
    path: 'templates/KO/system-admin/qs-data-hub/industry/industry-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/industry/industry-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminIndustryGrid'
});
qsTemplate.create('system-admin-aggregated-subject', {
    path: 'templates/KO/system-admin/qs-data-hub/aggregated-subject/aggregated-subject-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/aggregated-subject/aggregated-subject-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminAggregatedSubjectGrid'
});

qsTemplate.create('system-admin-aggregated-industry', {
    path: 'templates/KO/system-admin/qs-data-hub/aggregated-industry/aggregated-industry-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/aggregated-industry/aggregated-industry-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminAggregatedIndustryGrid'
});

qsTemplate.create('system-admin-wurd', {
    path: 'templates/KO/system-admin/qs-data-hub/wurd/wurd-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/wurd/wurd-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminWurdGrid'
});

qsTemplate.create('system-admin-nombycountryyoy', {
    path: 'templates/KO/system-admin/qs-data-hub/nomByCountryYoy/nomByCountryYoy-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/nomByCountryYoy/nomByCountryYoy-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminNomByCountryYoyGrid'
});

qsTemplate.create('system-admin-nombycountryagg', {
    path: 'templates/KO/system-admin/qs-data-hub/nomByCountryAGG/nomByCountryAGG-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/nomByCountryAGG/nomByCountryAGG-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminNomByCountryAGGGrid'
});

qsTemplate.create('system-admin-reference-list', {
    path: 'templates/KO/system-admin/referenceList/referenceList.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/referenceList/referenceList.js'],
    viewModelName: 'moveInViewModel.systemAdminReferenceList'
});

qsTemplate.create('system-admin-participationrateyoy', {
    path: 'templates/KO/system-admin/qs-data-hub/participationRateYoy/participationRateYoy-grid.html',
    js: ['templates/KO/advanced-grid/movein-advanced-grid.js', 'templates/KO/system-admin/qs-data-hub/participationRateYoy/participationRateYoy-grid.js'],
    viewModelName: 'moveInViewModel.systemAdminParticipationRateYoyGrid'
});